// Double facteur des admins (lots S1.4a et S1.4b), sans dépendance : le backend émet et vérifie
// les codes, le back-office en contrôle la forme et lit les refus. Deep-import uniquement
// (`@gozoki/api-types/src/validation/adminMfa`).

/** Chiffres d'un code TOTP, comme les applications d'authentification les affichent. */
export const TOTP_CODE_LENGTH = 6

/** Forme d'un code TOTP : exactement `TOTP_CODE_LENGTH` chiffres. */
export const TOTP_CODE_PATTERN = new RegExp(`^\\d{${TOTP_CODE_LENGTH}}$`)

/** Refus propres aux routes du double facteur (contrat `{ code, message }`). */
export const ADMIN_MFA_ERROR_CODES = {
  /** Défi inconnu, expiré, déjà levé ou annulé : reprendre la connexion par mot de passe. */
  challengeInvalid: 'mfa_challenge_invalid',
  /** Code refusé : le défi reste ouvert pour un autre essai. */
  codeInvalid: 'mfa_code_invalid',
  /**
   * Compte soumis à l'obligation (S1.4b), date passée, pas encore enrôlé : seul l'enrôlement est
   * ouvert (`services/auth/mfa/obligation.ts` du backend).
   */
  enrollmentRequired: 'mfa_enrollment_required',
} as const
